import { render } from "./Assistant.vue?vue&type=template&id=9141c402&scoped=true&ts=true"
import script from "./Assistant.vue?vue&type=script&lang=ts"
export * from "./Assistant.vue?vue&type=script&lang=ts"

import "./Assistant.vue?vue&type=style&index=0&id=9141c402&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9141c402"]])

export default __exports__